export function createPackagingDocumentPreviewUrl(file: File): string | null {
  if (file.type.startsWith('image/')) {
    return URL.createObjectURL(file)
  }
  return null
}

export function revokePackagingDocumentPreviewUrl(url: string | null) {
  if (url != null) {
    URL.revokeObjectURL(url)
  }
}

export function formatPackagingDocumentFileSize(bytes: number): string {
  if (bytes >= 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  }
  if (bytes >= 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`
  }
  return `${bytes} B`
}

export function pickSinglePackagingUploadFile(files: File[]): {
  file: File
  extraFilesIgnored: number
} {
  return {
    file: files[0],
    extraFilesIgnored: Math.max(0, files.length - 1),
  }
}
